import { FC } from 'react'
import { useAnalytics } from '@/contexts/AnalyticsProvider'
import scss from './Released.scss'
import { RELEASED_CHANGELOG_TRIGGER_ID } from './released-constants'

type ReleasedButtonProps = {
  className?: string
  spanClassName?: string
  icon: string
  disabled?: boolean
  tooltipContent?: string
  ariaLabel: string
}

export const ReleasedButton: FC<ReleasedButtonProps> = ({
  className,
  spanClassName,
  icon,
  disabled = false,
  tooltipContent = "What's New",
  ariaLabel,
}) => {
  const { trackEvent } = useAnalytics()

  const handleClick = () => {
    if (disabled) return
    trackEvent('released_dialog_opened', {
      tool_name: 'whats_new',
      tool_state: 'opened',
    })
  }

  return (
    <button
      type='button'
      id={RELEASED_CHANGELOG_TRIGGER_ID}
      className={`${scss.releasedButton} ${className ?? ''}`}
      onClick={handleClick}
      data-tooltip-content={tooltipContent}
      data-tooltip-id='sideNav'
      data-effect='solid'
      data-arrow-color='rgba(0, 0, 0, 0.68)'
      aria-label={ariaLabel}
      aria-disabled={disabled}
      tabIndex={0}
      disabled={disabled}
    >
      <span className={spanClassName}>
        <img src={icon} alt="What's New" />
      </span>
    </button>
  )
}
